import { Link } from "gatsby";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1600 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 1599, min: 1400 },
    items: 3,
  },
  tabletlandscape: {
    breakpoint: { max: 1399, min: 1200 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1199, min: 667 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 666, min: 0 },
    items: 1,
  },
};

const Industrydubai = () => {
  return (
    <div className="industry_gcc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto dark_bg text-center"
          >
            <div className="industy_head">
              <h2>
                Explore a Multitude of Genres with Our{" "}
                <span>Game Development Company</span>
              </h2>
              <p>
                As one of the leading game development companies in KSA, we
                pride ourselves on creating diverse gaming experiences.
              </p>
              <p>
                Our studio crafts games across various genres, including action,
                adventure, strategy, role-playing (RPG), simulation, puzzle,
                sports, racing, fighting, horror, stealth, and educational.
              </p>
              <p>
                No matter your preference, our commitment to excellence ensures
                unforgettable gaming experiences tailored to every player's
                tastes and desires.
              </p>
              <p>
                Join hands with us to bring your gaming vision to life. Our team
                of passionate developers, artists, and designers is ready to
                collaborate with you to create the next big hit!
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Connect!
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Industrydubai;
